/******************************************************************************
 * Copyright 2022 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/

export {
    AmbiguityReport,
    LLStarLookaheadOptions,
    LLStarLookaheadStrategy
} from './all-star-lookahead.js';
